import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { estReserveAuxAdmins } from '../lib/acces';

/**
 * Accueil — redirige vers l'écran de démarrage adapté au rôle.
 *
 * Historique : la spec Ben du 18/07 envoyait tout le monde sur
 * `/pilotage-achats` (l'ancienne liste de modules découverts vivait ici).
 * Depuis l'authentification du 01/08, ce dashboard est **réservé aux admins** —
 * un simple utilisateur atterrissait donc, juste après s'être connecté, sur un
 * écran dont l'onglet lui est masqué et dont l'API refuse les données (403).
 * Rien ne fuitait, mais sa première impression était une page en erreur.
 *
 * On envoie donc chacun là où il a le droit d'aller : le pilotage pour les
 * admins, les Commandes MP — le quotidien de l'atelier — pour les autres.
 */
const ACCUEIL_ADMIN = 'pilotage-achats';
const ACCUEIL_UTILISATEUR = 'commandes';

export default function HomeRoute(): JSX.Element {
  const { utilisateur } = useAuth();
  const estAdmin = utilisateur?.role === 'admin' || utilisateur?.estSuperAdmin === true;
  // Ceinture et bretelles : si la destination admin devenait un jour un écran
  // NON réservé, la condition reste juste sans qu'on ait à y repenser.
  const cible = estAdmin || !estReserveAuxAdmins(ACCUEIL_ADMIN) ? ACCUEIL_ADMIN : ACCUEIL_UTILISATEUR;
  return <Navigate to={`/${cible}`} replace />;
}
